import { useMemo } from 'react';
import dynamic from 'next/dynamic';

import { isScottishPostCode } from '@utils/postcode-validation';
import { Experiment, useOptimizely } from 'lib/sdks/optimizely';

const ScotlandBanner = dynamic(() => import('./ScotlandBanner/ScotlandBanner'));
const DefaultBanner = dynamic(() => import('./DefaultBanner'));

const GuaranteeBanner = ({ postcode }: { postcode?: string }) => {
  const { decide, loading: optimizelyLoading } = useOptimizely();

  const showScottishBanner = isScottishPostCode(postcode);

  const showGuaranteeBanner = useMemo(() => {
    if (optimizelyLoading || showScottishBanner) return false;

    const decision = decide(Experiment.GUARANTEE_BANNER);
    return decision?.variationKey === 'with_banner';
  }, [showScottishBanner, decide, optimizelyLoading]);

  if (showScottishBanner) return <ScotlandBanner />;

  return showGuaranteeBanner ? <DefaultBanner /> : null;
};

export default GuaranteeBanner;
